import type { ChordConfidence } from '@tunasong/models'
import styles from './chord-confidence.module.css'

/**
 * Map a `ChordAnalysis.confidence` to a CSS class for visual treatment.
 *
 * - `high` → `null` (no class; render as-is)
 * - `medium` → de-emphasised (70% opacity)
 * - `low` → hidden (`display: none`)
 *
 * Apply this to the function tag / chip / parenthetical / description — NOT
 * to the chord name. The chord name is always rendered regardless of
 * confidence. See `chord-confidence.module.css` for rationale.
 */
export const getChordConfidenceClassName = (confidence: ChordConfidence): string | undefined => {
  if (confidence === 'medium') {
    return styles.medium
  }
  if (confidence === 'low') {
    return styles.low
  }
  return undefined
}

/**
 * Convenience predicate: should the function label be rendered at all?
 *
 * Returns `false` only for `'low'`. Callers that prefer to omit the surrounding
 * markup entirely (e.g. an aria-label-bearing chip) can use this instead of
 * the `low` CSS class.
 */
export const shouldRenderChordConfidenceLabel = (confidence: ChordConfidence): boolean => confidence !== 'low'
